import './App.css';
import About from './components/sections/About';
import Contact from './components/sections/Contact';
import Hero from './components/sections/Hero';
import Work from './components/sections/Work';
import Blog from './components/sections/Blog';
import Sidebar from './components/Sidebar';

function App() {
  return (
    <div className="App">
      {/* <Loader /> */}
      <Sidebar />
      <div className="right">
        <Hero />
        <About />
        <Work />
        <Blog />
        <Contact />
      </div>
    </div>
  );
}

export default App;
